import { render } from "./ResignPopup.vue?vue&type=template&id=47403532&scoped=true"
import script from "./ResignPopup.vue?vue&type=script&lang=js"
export * from "./ResignPopup.vue?vue&type=script&lang=js"

import "./ResignPopup.vue?vue&type=style&index=0&id=47403532&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47403532"]])

export default __exports__